<template>
  <div id="main">
    <router-view />
  </div>
</template>

<script>
import { computed, provide, reactive, ref, inject, onMounted } from "vue";
import { useRouter } from 'vue-router';  // ルーター監視用に追加

export default {
  name: "App",
  setup() {
    const router = useRouter();

    // b-dashページビュートラッキング関数
    const trackBDashPageView = () => {
      if (typeof bdash4 !== 'undefined') {
        // URLの更新
        bdash4("set", { location: document.location.href });
        
        // ページタイトルの更新
        bdash4("set", { pageTitle: document.title });
        
        // リファラーの更新
        bdash4("set", { referrer: document.referrer });
        
        // prevPageの更新処理
        const getPrevPage = () => {
          const cookies = document.cookie.split(";");
          const regex = new RegExp("^s*" + '_bd_prev_page' + "=s*(.*)s*$");
          
          for (const cookie of cookies) {
            const val = cookie.match(regex);
            if (!val) continue;
            
            let value;
            // @から始まっている場合
            if (val[1].indexOf('@') === 0) {
              try {
                value = decodeURIComponent(window.BdashRawDeflate.inflate(window.atob(val[1].slice(1))));
              } catch (e) {
                value = val[1];
              }
            } 
            // @から始まっていない場合
            else {
              try {
                value = decodeURIComponent(window.atob(val[1]));
              } catch (e) {
                value = val[1];
              }
            }
            
            const result = value && value.match(/^BD.(.+).(d+)$/);
            return result ? result[1] : value;
          }
          return null;
        };

        const prevPage = getPrevPage();
        if (prevPage) {
          bdash4("set", { prevPage });
        }
        
        // タグ発火
        bdash4("send", { type: "pageview" });
      }
    };

    // b-dashスクリプトの読み込み
    const loadBDashScript = () => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = '//cdn.activity.smart-bdash.com/tag-manager/bd-yx7oc8/btm.js';
      script.charset = 'UTF-8';
      script.async = true;
      document.head.appendChild(script);

      // スクリプト読み込み完了後のチェック
      script.onload = () => {
        // 初回ページビューのトラッキング
        setTimeout(trackBDashPageView, 1000); // スクリプト初期化待ち
      };
    };

    onMounted(() => {
      // b-dashスクリプトの読み込み
      if (!document.querySelector('script[src*="smart-bdash.com"]')) {
        loadBDashScript();
      }
    });

    // ルート変更時のトラッキング
    router.afterEach((to, from) => {
      // ページ遷移時にb-dashトラッキングを実行
      setTimeout(trackBDashPageView, 100); // ページ遷移完了待ち
    });

    return {};
  },
};
</script>